// @flow

import type { Reducer } from 'redux';
import { createAction, createReducer } from 'redux-act';

import type { FullState, SupportState } from '../../types';

export const setBackUrlParams: any = createAction('[SUPPORT] Set the back url');
export const saveQuestionId: any = createAction(
  '[SUPPORT] save suggestion question_id qbot'
);

// Selector
export const selectQuestionId = (state: FullState): string => {
  return state.support.layout.questionId;
};

// Reducer
const initialState: SupportState['layout'] = {
  backUrl: '',
  currentUrl: '',
  questionId: '',
};
const setBackUrlParamsHandler = (
  state: SupportState['layout'],
  payload: {|
    backUrl: string,
    currentUrl: string,
  |}
) => ({
  ...state,
  backUrl: payload.backUrl,
  currentUrl: payload.currentUrl,
});
const saveQuestionIdHandler = (
  state: SupportState['layout'],
  questionId: string
) => ({
  ...state,
  questionId,
});

// $FlowFixMe[incompatible-exact]
const reducer: Reducer<SupportState['layout'], mixed> = createReducer(
  {
    [setBackUrlParams]: setBackUrlParamsHandler,
    [saveQuestionId]: saveQuestionIdHandler,
  },
  initialState
);
export default reducer;
